import one from "../images/Travels/Work1_optimized_750.jpg";
import two from "../images/Travels/Tour-main.jpg";
import three from "../images/Travels/cox.jpg";
import four from "../images/Travels/Tour-1.jpg";
import five from "../images/Travels/Tour-ratar.jpg";
import six from "../images/Travels/tour-4.jpg";
import seven from "../images/Travels/Bagerhat.jpg";
import eight from "../images/Travels/Tour-3.JPG";
import nine from "../images/Travels/university-main.jpg";
import zero from '../images/Travels/presentation.jpg';
import zeroPointOne from '../images/Travels/Huawei.jpg';
import zeroPointTwo from '../images/Travels/Work3_optimized_250.jpg';
import viva from '../images/Travels/viva.jpg';
import nilgiri from '../images/Travels/Nilgiri.jpg';
import omeca from '../images/Travels/omeca.jpg';

export const imagesFolder = [

  {
    "img": zero,
    "alt": "Image 00"
  },
  {
    "img": zeroPointOne,
    "alt": "Image 0.1"
  },
  {
    "img": zeroPointTwo,
    "alt": "Image 0.2"
  },
  {
    "img": one,
    "alt": "Image 01"
  },
  {
    "img": two,
    "alt": "Image 02"
  },
  {
    "img": three,
    "alt": "Image 03"
  },
  {
    "img": four,
    "alt": "Image 04"
  },
  {
    "img": five,
    "alt": "Image 05"
  },
  {
    "img": six,
    "alt": "Image 06"
  },
  {
    "img": seven,
    "alt": "Image 07"
  },
  {
    "img": eight,
    "alt": "Image 08"
  }, {
    "img": nine,
    "alt": "Image 08"
  }
  , {
    "img": viva,
    "alt": "Image 08"
  }
  , {
    "img": nilgiri,
    "alt": "Image 08"
  }
  , {
    "img": omeca,
    "alt": "Image 08"
  }
];